/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { SearchInput } from '../../../../common/components/SearchInput'
import { BackofficePermissionsEnum as Permissions } from '../../../../common/enums/backOfficePermissionsEnum'
import { useDebounce } from '../../../../common/hooks/useDebounce'
import usePermissions from '../../../../common/hooks/usePermissions'
import { useStateCallback } from '../../../../common/hooks/useStateCallback'
import { IExportClient, IPaymentStatusEnum } from '../../../../common/interfaces'
import { useSolicitudes } from '../../hooks/useSolicitudes'
import { useSuscriptions } from '../../hooks/useSuscriptions'
import { Export } from '../Export'
import { Filter } from '../Filter'
import { StatusList } from '../StatusList'
import { SuscriptionTable } from '../tables/SuscriptionTable'

export type IFilterStatus = '-1' | '0' | '1' | '2' | ''
export interface IFilters {
  start_date: string
  end_date: string
  fund?: string
  status?: IFilterStatus
  sended_spectrum?: boolean
  scheduled_rescue?: boolean
}

const initialValue = {
  start_date: '',
  end_date: '',
  sended_spectrum: true,
}

export const SuscriptionTab = () => {
  const [search, setSearch] = useStateCallback<string>('')
  const debouncedSearch = useDebounce(search, 500)
  const [errors, setErrors] = useStateCallback<any>({
    comment: null,
  })
  const [selectedStatus, setSelectedStatus] = useStateCallback<null | IPaymentStatusEnum>(null)
  const [filters, setFilters] = useStateCallback<IFilters>(initialValue)
  const {
    changeStatusMutation,
    selectedSuscriptions,
    setSelectedSuscriptions,
    comment,
    setComment,
  } = useSuscriptions()
  const { hasPermission } = usePermissions()

  useEffect(() => {
    if (changeStatusMutation.isSuccess && selectedStatus === IPaymentStatusEnum.ANNULLED) {
      $('#comment-section').modal('toggle')
      setComment('')
    }
  }, [changeStatusMutation.isSuccess])

  const { exportMovements } = useSolicitudes()

  const handleExcelDownload = () => {
    let ex = {
      filter: filters,
      search: search,
    } as IExportClient
    exportMovements.mutate(ex)
  }

  return (
    <>
      <div className='card border-0 pt-5 border-radius-20px'>
        <div className='card-header border-bottom-0 mt-3'>
          <div className='d-flex align-items-center gap-5'>
            <SearchInput
              placeholder='🔍︎  Buscar movimiento'
              search={search}
              setSearch={setSearch}
            />
            <div
              style={{ background: 'rgb(0, 123, 195)' }}
              className='rounded p-2 d-flex justify-content-center align-items-center cursor-pointer'
              data-bs-toggle='modal'
              data-bs-target='#filter-subscriptions'
            >
              <i className='bi bi-filter fs-2 text-white'></i>
            </div>
            {selectedSuscriptions.length !== 0 && (
              <span className='text-muted d-block fs-6'>
                {selectedSuscriptions.length} Seleccionado{selectedSuscriptions.length > 1 && 's'}
              </span>
            )}
            {filters !== initialValue && (
              <span
                style={{
                  borderBottom: '1px inset #a1a5b7',
                }}
                onClick={() => setFilters(initialValue)}
                className='text-muted cursor-pointer d-block fs-6'
              >
                Limpiar filtros
              </span>
            )}
          </div>

          {hasPermission(Permissions.SUBSCRIPTION.EXPORT) && (
            <button
              style={{
                backgroundColor: '#007BC3',
                color: 'white',
                width: '180px',
                height: '42px',
              }}
              onClick={handleExcelDownload}
              className='btn text-end cursor-pointer w-200px'
            >
              <img
                style={{
                  marginRight: '5px',
                }}
                src={toAbsoluteUrl('/✅ Web - Mm/donwload.svg')}
                alt='plus'
                className='w-15px  '
              />
              Exportar Movimientos
            </button>
          )}
        </div>
        <Export />
        <div className='modal fade p-5 rounded-4' tabIndex={-1} id='comment-section' role='dialog'>
          <div className='modal-dialog rounded-4 modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header py-5 mt-2 fw-bolder'>
                <h1 className='text-alert'>Motivo de rechazo</h1>
              </div>

              <div className='modal-body'>
                <label className='text-muted fs-6 mb-2'>
                  Por favor ingrese el motivo de rechazo para {selectedSuscriptions.length}{' '}
                  suscripción seleccionada{selectedSuscriptions.length > 1 && 's'}:
                </label>
                <textarea
                  className='form-control form-control-solid mb-5'
                  name='export_range'
                  onChange={(e) => setComment(e.target.value)}
                  style={{ resize: 'none' }}
                  placeholder='Comentario'
                  value={comment}
                  onKeyUp={(e) => {
                    if (e.currentTarget.value.trim() === '') {
                      setErrors({
                        amount: 'Campo requerido',
                      })
                    } else if (e.currentTarget.value.trim().length < 2) {
                      setErrors({
                        comment: 'Debe contener mínimo dos caracteres',
                      })
                    } else {
                      setErrors({
                        amount: null,
                      })
                    }
                  }}
                  rows={5}
                />
                {errors['amount'] && (
                  <span className='text-danger' role='alert'>
                    {errors['amount']}
                  </span>
                )}
              </div>
              <div className='modal-footer py-2'>
                <div className='text-end'>
                  <button
                    style={{ backgroundColor: '#eee', color: '#969696' }}
                    type='button'
                    id='cancelButton'
                    className='btn btn col m-3'
                    data-bs-dismiss='modal'
                  >
                    Cancelar
                  </button>
                  <button
                    style={{
                      background: 'rgb(0, 123, 195)',
                      color: 'white',
                    }}
                    disabled={
                      errors['amount'] !== null ||
                      comment.trim() === '' ||
                      changeStatusMutation.isLoading
                    }
                    type='button'
                    className='btn btn col m-3 fw'
                    onClick={() =>
                      changeStatusMutation.mutate(
                        IPaymentStatusEnum.ANNULLED as unknown as IFilterStatus
                      )
                    }
                  >
                    <div className='d-flex gap-3 align-items-center'>Confirmar</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {selectedSuscriptions.length !== 0 && (
          <div
            style={{ border: '1px solid #eee' }}
            className='card-body rounded position-relative d-flex align-items-center justify-content-between w-450px mx-9 py-2'
          >
            <span className='text-muted' style={{ fontWeight: 600 }}>
              Cambiar a:
            </span>
            <StatusList
              mutate={changeStatusMutation.mutate}
              setSelectedStatus={setSelectedStatus}
              mutationLoading={changeStatusMutation.isLoading}
              showAnnulled={false}
              permissionGuards={{
                // si en el futuro quisieras permitir "Aprobar" acá:
                approve: Permissions.SUBSCRIPTION.SHOW, // o el que definas
              }}
            />
            <div
              onClick={() => setSelectedSuscriptions([])}
              style={{
                borderBottom: '1px inset #a1a5b7',
                position: 'absolute',
                right: '-130px',
              }}
              className='text-muted cursor-pointer'
            >
              Limpiar selección
            </div>
          </div>
        )}
        <SuscriptionTable
          search={search.length > 2 ? debouncedSearch! : ''}
          setSelectedSuscriptions={setSelectedSuscriptions}
          selectedSuscriptions={selectedSuscriptions}
          setSearch={setSearch}
          setFilters={setFilters}
          filters={filters}
          mutationSuccess={changeStatusMutation.isSuccess}
        />
      </div>
      <Filter setFilters={setFilters} filters={filters} />
    </>
  )
}
